import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";

export default function FoodCard({ artist }) {
  const image = artist.img ? require(`../../images/food/${artist.img}`) : null;

  return (
    <Card
      sx={{
        width: { xs: "100%", sm: "48%", md: "23%" },
        margin: { xs: "0 0 20px 0", sm: "1%", md: "1%" },
      }}
      className={`${artist.link ? "line-up-card" : "line-up-card dj-card"}`}
    >
      <CardActionArea href={artist.link || ""} target="_blank" className="line-up-card-area">
        {image && (
          <CardMedia
            component="img"
            image={image}
            alt={artist.name}
            className="artist-image"
          />
        )}
        <CardContent className="line-up-text-container">
          <Typography className="line-up-text" gutterBottom>
            {artist.name}
          </Typography>
          {artist.location && 
          <Typography className="line-up-location" gutterBottom>
            {artist.location}
          </Typography>
          }
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
